import { createClient } from '@supabase/supabase-js'
import { SUPABASE_URL, SUPABASE_KEY } from './database'

// Reuse the tab-wide shared client when the public-side scripts
// (subscription-gate.js, menu-starter-workflow.js, etc.) have already
// created one. Spinning up a second GoTrueClient against the same
// localStorage key causes refresh-token rotation races that surface as
// "Invalid Refresh Token: Refresh Token Not Found" — e.g. file imports
// failing with "Not authenticated. Please sign in and try again."
const existing = typeof window !== 'undefined' ? window.__MT_SHARED_SUPABASE__ : null
const supabase = existing || createClient(SUPABASE_URL, SUPABASE_KEY)

if (typeof window !== 'undefined' && !window.__MT_SHARED_SUPABASE__) {
  window.__MT_SHARED_SUPABASE__ = supabase
}

export default supabase
